import { useEffect } from 'react';
import { useFormik } from 'formik';
import { PqrHeadInfoProps } from './props';

export const usePqrHeadInfo = ({ pqr, onChangeFormik }: PqrHeadInfoProps) => {
    const formik = useFormik({
        initialValues: {
            consecutiveFormat: '',
            idSFC: '',
            callId: '',
            detail: '',
        },
        onSubmit: console.log,
    });

    useEffect(() => {
        if (onChangeFormik) onChangeFormik(formik);
    }, [formik.values, formik.errors]);

    useEffect(() => {
        formik?.setFieldValue(
            'consecutiveFormat',
            pqr?.consecutiveFormat || ''
        );
        formik?.setFieldValue('callId', pqr?.callInfo?.callId || '');
        formik?.setFieldValue('detail', pqr?.info?.detail || '');
        formik?.setFieldValue('idSFC', pqr?.dataSfc?.sfcId || '');
    }, [pqr]);

    return {
        formik,
    };
};
